import { ConfigLoader, DashboardSdk } from '@bringg/frontend-utils';
import { Environment } from '@bringg/frontend-utils/dist/common/types';

const commonRegionKeyNames = ['web_app_url'];
const regionSpecificKeyNames = ['services_end_point'];

async function initDashboardSdk(): Promise<DashboardSdk> {
  const configLoader = new ConfigLoader();
  let commonRegionConfigKeys, specificRegionConfigKeys;

  const envConfig: Environment = await configLoader.loadWithInjectedFallbackRegions({
    fallbackRegionsConfigPath: 'fallback_configurations/',
    commonRegionKeyNames,
    regionSpecificKeyNames,
  });

  if (['production', 'staging', 'edge'].includes(envConfig.environment)) {
    ({ commonRegionKeys: commonRegionConfigKeys, regionSpecificKeys: specificRegionConfigKeys } =
      configLoader.getRegionsKeys(envConfig, commonRegionKeyNames, regionSpecificKeyNames));
  }

  console.log(`current env: ${envConfig.environment}`);

  return new DashboardSdk({
    appName: 'Bringg Dashboard',
    config: envConfig,
    commonRegionConfigKeys,
    specificRegionConfigKeys,
  });
}

const promiseDashboardSdk = initDashboardSdk();

export function getDashboardSdk(): Promise<DashboardSdk> {
  return promiseDashboardSdk;
}
